import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VCard,{attrs:{"elevation":"0"}},[_c(VCardText,[_c(VBtn,{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-arrow-left")]),_vm._v(" Back to checklist ")],1)],1),_c(_vm.component,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }